<div class="information-preview">
  <cdk-virtual-scroll-viewport class="virtual-scroll-container" [itemSize]="3">
    <ng-container *cdkVirtualFor="let info of data; trackBy: trackByFn; templateCacheSize: 0">
      <div class="info-box">
        <div class="info-details">
          <div class="info-pic">
            <img alt="pic" class="pic" [appLazyLoadImg]="info.pic" />
          </div>
          <div class="info">
            <div class="info-title">{{ info.title }}</div>
            <div class="info-type-date">
              <div class="info-type" [ngClass]="{ 'primary-bg': info.typeId === 2, 'complaint-bg': info.typeId === 3 }">
                <app-svg-icon *ngIf="info.typeId === 3" class="tile-type-icon" src="./assets/icons/file-4px.svg"></app-svg-icon>
                {{ info.type.name }}
              </div>
              <div class="date-container" *ngIf="info.typeId === 2">
                <div class="info-date" *ngIf="info.dateDisplay">
                  <span class="fa fa-clock-o" aria-hidden="true" [ngClass]="info.typeId === 2 ? 'primary-text-color' : ''"></span>
                  <span [ngClass]="info.typeId === 2 ? 'primary-text-color' : ''">{{ info.dateDisplay }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-desc" [innerHTML]="info.description"></div>
        <span class="button" (click)="$event.stopPropagation(); select(info)">Mehr anzeigen</span>
      </div>
      <mat-divider class="divider"></mat-divider>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
